import React, { ReactElement } from 'react';

import { SessionDataTable } from './SessionDataTable';
import { BaseContainer } from '../../../layout/BaseContainer';

export function SessionListPage(): ReactElement {
  return (
    <BaseContainer>
      <div className="lists-title">
        <h1>Formations présentielles</h1>
        <h2 className="mt-4 plus">Sessions de formation</h2>
      </div>
      <div className="pt-5">
        <SessionDataTable />
      </div>
    </BaseContainer>
  );
}
